'use client';

// npm packages
import React, { useEffect, useState } from 'react';

// utils
import { OTP_LENGTH } from '@/constants';
import { useDispatch, useSelector } from 'react-redux';
import { verifyOtp } from '@/redux/thunk/my-profile-thunk';
import { cn } from '@/utils/cn';
// components
import Button from '../Button';
import Text from '../Text';
import MyProfileResendOTP from './MyProfileResendOTP';
import MyProfileOTPNumberInput from './MyProfileOTPNumberInput';
import MyProfileHeader from './MyProfileHeader';

function OTP({ activeTab, userInfo }) {
  const dispatch = useDispatch();
  const [otp, setOtp] = useState([]);

  const { errorMessage, isNumberOfAttemptExceeded } = useSelector(
    (state) => state.myProfile,
  );

  useEffect(() => {
    if (errorMessage.length) {
      setOtp([]);
    }
  }, [errorMessage]);

  const handleOtpSubmit = async () => {
    await dispatch(verifyOtp({ otp }));
  };

  return (
    <div className="bg-white rounded-xl flex flex-col items-center p-24">
      <MyProfileHeader
        type="otpForm"
        userInfo={userInfo}
        activeTab={activeTab}
      />

      {/* OTP Number Input */}
      <MyProfileOTPNumberInput
        otp={otp}
        setOtp={setOtp}
        activeTab={activeTab}
      />

      {!isNumberOfAttemptExceeded ? (
        <Button
          type="primary"
          className={cn(
            'min-w-[80px] bg-tealgreen text-white py-12 px-10 rounded-[100px] gap-2 !text-16 w-full !font-bold focus:outline-none focus:ring-0 my-24',
            (otp.length < OTP_LENGTH || isNumberOfAttemptExceeded) &&
              '!bg-aquarelle-purple !text-atelier !border-himalayan-poppy',
          )}
          onClick={handleOtpSubmit}
          disabled={otp.length < OTP_LENGTH || isNumberOfAttemptExceeded}
        >
          <Text
            type="span"
            className="text-16 text-inherit font-semibold font-encode-sans leading-24 tracking-[0.32px]"
          >
            Continue
          </Text>
        </Button>
      ) : null}

      {/* Resend Otp */}
      <MyProfileResendOTP />
    </div>
  );
}

export default OTP;
